/**
 * Created by claudio iozzia on 11/07/2017.
 */
import {Ic} from "../../../../models/common";
import {Validator_DcLED_Buck} from "./dcLED_buck_validator";
import {Range} from '../../../../common/Range';
import {IAppSpec} from "../../../../Redux/selector.state";
import {Utils} from "../../../../common/utils";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";

export class Validator_DcLED_BuckBoost extends Validator_DcLED_Buck {
  protected getVoutBounds(ic: Ic, spec: IAppSpec): Range {
    const _vin = spec.spec.value.input;
    const _vin_note = spec.spec.note.input;

    const isAttendibileVinMax: boolean = !_vin_note.max.hasError && Utils.isValueReal(_vin.max);
    return new Range(ic.vout_min, isAttendibileVinMax ? ic.vout_max - _vin.max : ic.vout_max);
  }

  protected getIoutBounds(ic: Ic, spec: IAppSpec): Range {
    const _vin = spec.spec.value.input;
    const _vin_note = spec.spec.note.input;
    const _specVout = spec.spec.value.output.globalOutput.voltage;

    const isAttendibileVinMin: boolean = !_vin_note.min.hasError && Utils.isValueReal(_vin.min);
    const isFiniteVout: boolean = Utils.isValueReal(_specVout);
    let maxIout: number = ic.iout_max;
    if (isAttendibileVinMin && isFiniteVout) {
      const idealDuty: number = _specVout / (_specVout + _vin.min);
      const maxIoutForDuty: number = ValueFormatter.scale(maxIout * (1 - idealDuty), siPrefix.unit);
      maxIout = Math.min(maxIout, maxIoutForDuty);
    }
    return new Range(Number.NEGATIVE_INFINITY, maxIout);
  }
}
